(function () {
  if (window.__madesaCuponsSectionDiscountInit) return;
  window.__madesaCuponsSectionDiscountInit = true;

  function getCuponsI18n() {
    const defaults = {
      copy_success_pop: 'Coupon copied successfully!',
      copy_error_pop: 'Could not copy. Copy the code manually.',
      toast_apply_success: 'Coupon applied successfully!',
      label_code_applied: 'Coupon applied',
      aria_code_applied: 'Coupon applied',
      toast_saved_cart: 'Coupon saved to your cart; add an eligible product.',
      label_code_in_cart: 'Coupon in cart',
      aria_code_in_cart: 'Coupon saved to your cart; add an eligible product.',
      toast_not_eligible: 'The items in your cart are not eligible for this coupon.',
      toast_invalid: 'Invalid or expired coupon.',
      label_code_invalid: 'INVALID COUPON',
      aria_code_invalid: 'Invalid or expired coupon',
      apply_coupon_aria: 'Apply coupon {{ code }}',
    };
    if (window.__madesaCuponsI18nParsed !== undefined) {
      return window.__madesaCuponsI18nParsed;
    }
    const el = document.querySelector('[data-madesa-cupons-i18n]');
    if (!el) {
      window.__madesaCuponsI18nParsed = defaults;
      return window.__madesaCuponsI18nParsed;
    }
    try {
      const parsed = JSON.parse(el.textContent.trim());
      const out = { ...defaults };
      for (const key of Object.keys(parsed)) {
        if (parsed[key] != null && parsed[key] !== '') {
          out[key] = parsed[key];
        }
      }
      window.__madesaCuponsI18nParsed = out;
    } catch (err) {
      window.__madesaCuponsI18nParsed = defaults;
    }
    return window.__madesaCuponsI18nParsed;
  }

  function applyAriaTemplate(tpl, code) {
    if (!tpl || !code) return '';
    return String(tpl)
      .replace(/\{\{\s*code\s*\}\}/gi, code)
      .replace(/\{\{code\}\}/gi, code);
  }

  function cartHasDiscount(cart) {
    const hasCartLevel =
      cart.cart_level_discount_applications &&
      cart.cart_level_discount_applications.length > 0;
    const hasItemLevel =
      cart.items &&
      cart.items.some(
        (item) =>
          item.line_level_discount_allocations &&
          item.line_level_discount_allocations.length > 0
      );
    return hasCartLevel || hasItemLevel;
  }

  function findDiscountCodeEntry(cart, code) {
    const normalized = code.trim().toLowerCase();
    if (!normalized || !Array.isArray(cart.discount_codes)) return null;
    return (
      cart.discount_codes.find(
        (d) => d.code && String(d.code).trim().toLowerCase() === normalized
      ) || null
    );
  }

  function showToast(message, type) {
    document.dispatchEvent(
      new CustomEvent('toast:show', {
        detail: {
          message,
          type: type || 'success',
          duration: TOAST_DURATION_MS,
        },
      })
    );
  }

  const LABEL_RESTORE_MS = 4000;
  const TOAST_DURATION_MS = 5500;

  function getCodeDisplayEl(card) {
    if (!card) return null;
    return card.querySelector('.madesa-cupom-card__code-box .madesa-cupom-card__code');
  }

  function setCodeBoxLabel(card, codeText, applyAriaLabel) {
    if (!card) return;
    const codeSpan = getCodeDisplayEl(card);
    if (codeSpan) {
      codeSpan.textContent = codeText;
    }
    const applyBtn = card.querySelector('.madesa-cupom-card__apply[data-apply-discount]');
    if (applyBtn && applyAriaLabel) {
      applyBtn.setAttribute('aria-label', applyAriaLabel);
    }
  }

  function buildCodeBoxRestoreState(card, couponAttr) {
    if (!card || !couponAttr) return null;
    const trimmed = couponAttr.trim();
    const applyBtn = card.querySelector('[data-apply-discount]');
    const i = getCuponsI18n();
    const aria =
      (applyBtn && applyBtn.getAttribute('aria-label')) ||
      applyAriaTemplate(i.apply_coupon_aria, trimmed);
    return { codeText: trimmed, ariaLabel: aria || trimmed };
  }

  function scheduleRestoreInitialCodeBox(card, state) {
    if (!card || !state) return;
    const prev = card.__madesaCupomLabelRestoreTimer;
    if (prev) clearTimeout(prev);
    card.__madesaCupomLabelRestoreTimer = setTimeout(() => {
      setCodeBoxLabel(card, state.codeText, state.ariaLabel);
      card.__madesaCupomLabelRestoreTimer = null;
    }, LABEL_RESTORE_MS);
  }

  function applyCoupon(code) {
    const trimmed = code.trim();

    const updatePromise =
      typeof window.madesaUpdateCartDiscount === 'function'
        ? window.madesaUpdateCartDiscount(trimmed)
        : fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ discount: trimmed }),
          }).then((response) => {
            if (!response.ok) throw new Error('fail');
            return response.json();
          });

    return updatePromise.then((cart) => {
      if (cartHasDiscount(cart)) return { cart, state: 'applied' };

      const entry = findDiscountCodeEntry(cart, trimmed);
      const itemCount =
        cart.items && Array.isArray(cart.items) ? cart.items.length : 0;

      if (entry) {
        if (itemCount > 0 && entry.applicable === false) {
          return { cart, state: 'not_eligible' };
        }
        return { cart, state: 'saved' };
      }

      throw new Error('invalid');
    });
  }

  function copyCouponCode(text) {
    const value = text.trim();
    if (!value) return Promise.reject();
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(value);
    }
    return new Promise((resolve, reject) => {
      try {
        const ta = document.createElement('textarea');
        ta.value = value;
        ta.setAttribute('readonly', '');
        ta.style.position = 'fixed';
        ta.style.left = '-9999px';
        document.body.appendChild(ta);
        ta.select();
        const ok = document.execCommand('copy');
        document.body.removeChild(ta);
        ok ? resolve() : reject();
      } catch (e) {
        reject();
      }
    });
  }

  function hideCopyPop(el) {
    if (!el || !el.parentNode) return;
    el.classList.add('madesa-cupom-copy-pop--out');
    window.setTimeout(() => {
      el.remove();
    }, 200);
  }

  function showCopyPop(anchorEl, message, variant) {
    document.querySelectorAll('.madesa-cupom-copy-pop').forEach((n) => hideCopyPop(n));

    const el = document.createElement('div');
    el.className = 'madesa-cupom-copy-pop';
    if (variant === 'error') {
      el.classList.add('madesa-cupom-copy-pop--error');
    }
    el.setAttribute('role', 'status');
    el.textContent = message;
    document.body.appendChild(el);

    const place = () => {
      const rect = anchorEl.getBoundingClientRect();
      const gap = 8;
      const w = el.offsetWidth;
      const h = el.offsetHeight;
      let left = rect.left + rect.width / 2 - w / 2;
      left = Math.max(10, Math.min(left, window.innerWidth - w - 10));
      let top = rect.top - h - gap;
      if (top < 10) {
        top = rect.bottom + gap;
      }
      el.style.left = `${Math.round(left)}px`;
      el.style.top = `${Math.round(top)}px`;
    };

    el.style.visibility = 'hidden';
    place();
    el.style.visibility = '';

    const onWin = () => place();
    window.addEventListener('scroll', onWin, true);
    window.addEventListener('resize', onWin);

    const hide = () => {
      window.removeEventListener('scroll', onWin, true);
      window.removeEventListener('resize', onWin);
      hideCopyPop(el);
    };

    window.setTimeout(hide, 2400);
  }

  document.addEventListener('click', function (e) {
    const root = e.target.closest('.madesa-cupons');
    if (!root) return;

    const i = getCuponsI18n();

    const copyTrigger = e.target.closest('[data-copy-coupon]');
    if (copyTrigger) {
      e.preventDefault();
      const code = copyTrigger.getAttribute('data-copy-coupon');
      if (!code || !code.trim()) return;
      copyCouponCode(code)
        .then(() => {
          showCopyPop(copyTrigger, i.copy_success_pop || '');
        })
        .catch(() => {
          showCopyPop(copyTrigger, i.copy_error_pop || '', 'error');
        });
      return;
    }

    const trigger = e.target.closest('[data-apply-discount]');
    if (!trigger) return;

    e.preventDefault();

    if (typeof window.madesaMarkPdpCouponIntent === 'function') {
      window.madesaMarkPdpCouponIntent();
    }

    const code = trigger.getAttribute('data-apply-discount');
    if (!code || !code.trim()) return;

    const card = trigger.closest('.madesa-cupom-card');
    const restoreState = buildCodeBoxRestoreState(card, code);

    if (card && card.__madesaCupomLabelRestoreTimer) {
      clearTimeout(card.__madesaCupomLabelRestoreTimer);
      card.__madesaCupomLabelRestoreTimer = null;
    }

    const applyBtn = card ? card.querySelector('.madesa-cupom-card__apply[data-apply-discount]') : trigger;
    const controls = applyBtn ? [applyBtn] : [trigger];

    controls.forEach((el) => {
      el.disabled = true;
    });

    applyCoupon(code)
      .then(({ state }) => {
        if (typeof window.madesaSaveDiscountCode === 'function') {
          window.madesaSaveDiscountCode(code);
        }
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        if (state === 'applied') {
          showToast(i.toast_apply_success || '', 'success');
          setCodeBoxLabel(card, i.label_code_applied || '', i.aria_code_applied || '');
        } else if (state === 'not_eligible') {
          showToast(i.toast_not_eligible || '', 'error');
          setCodeBoxLabel(card, i.label_code_invalid || '', i.aria_code_invalid || '');
        } else {
          showToast(i.toast_saved_cart || '', 'info');
          setCodeBoxLabel(
            card,
            i.label_code_in_cart || '',
            i.aria_code_in_cart || ''
          );
        }
        scheduleRestoreInitialCodeBox(card, restoreState);
      })
      .catch(() => {
        showToast(i.toast_invalid || '', 'error');
        setCodeBoxLabel(card, i.label_code_invalid || '', i.aria_code_invalid || '');
        scheduleRestoreInitialCodeBox(card, restoreState);
      })
      .finally(() => {
        controls.forEach((el) => {
          el.disabled = false;
        });
      });
  });
})();
